import { ICycle } from 'models/cycle/cycle.model';
import { useEffect, useMemo, useState } from 'react';
import { useCycleList } from 'services/queryClient/wrapperHooks/cycle/useCycleList';

const sortCycles = (cycles: ICycle[]): ICycle[] => {
	return [...cycles].sort((a, b) => {
		if (a.ano !== b.ano) return b.ano - a.ano;
		return b.ciclo - a.ciclo;
	});
};

export const useCycleSelector = (initial?: ICycle) => {
	const { data: cyclesData } = useCycleList();

	const cycles = useMemo(() => {
		return cyclesData ? sortCycles(cyclesData) : [];
	}, [cyclesData]);

	const [selectedCycle, setSelectedCycle] = useState<ICycle | undefined>(
		initial
	);

	useEffect(() => {
		setSelectedCycle(initial);
	}, [initial?.id]);

	return {
		cycles,
		selectedCycle,
		setSelectedCycle,
	} as const;
};
